import information from './information';

interface iRouter {
  label: string;
  path: string;
}

type iIntro = Record<iRouter['path'], iIntroDetail>;

interface iIntroDetail {
  no: number;
  path: string;
  label: string;
  title: string;
  detail: string;
  tel: string;
  tel2?: string;
  scroll: string;
}

interface iLanding {
  intro: iIntro;
}

const Landing: iLanding = {
  intro: {
    '/': {
      no: 0,
      label: '지점을 선택하세요',
      path: '',
      title: '',
      detail: '',
      tel: '',
      scroll: '',
    },
    onedang: {
      no: 1,
      path: 'onedang',
      label: '인천 원당 1호점',
      title: '인천 원당점(비과밀억제권역)',
      detail: `온잇 공유오피스는 여러분의 비즈니스에 최적화된 업무 공간을 제공합니다.
인천검단신도시에 인접해있으며 상주/비상주 사무실을 합리적인 가격으로 이용할 수 있습니다.`,
      tel: '032)715-7555',
      scroll: '오픈 기념 이벤트 특가를 놓치기 싫다면?',
    },
    pyeongtaek: {
      no: 2,
      path: 'pyeongtaek',
      label: '경기 평택 2호점',
      title: '경기 평택점(비과밀억제권역)',
      detail: `법인|개인 사업자 등록을 위한 주소지제공 서비스를 전국 최저가로 제공합니다.
맞춤책상과 전좌석 시디즈 의자를 갖춘 편리한 업무 및 스터디 공간으로 이용할 수 있습니다.`,
      tel: '031)373-6128',
      scroll: '오픈 기념 이벤트 특가를 놓치기 싫다면?',
    },
    yeongdeungpo: {
      no: 3,
      path: 'yeongdeungpo',
      label: '서울 영등포구청 3호점',
      title: '영등포구청점(역세권 도보5분)',
      detail: `최신인테리어와 넓은 1인실,2인실을 가성비 있는 가격으로 상주 사무실을 이용 가능합니다.
비상주 사무실은 오픈행사 영등포 최저가로 할인 및 추가제공합니다(변동). 
      `,
      tel: '02)2633-7004',
      scroll: '오픈 기념 이벤트 특가를 놓치기 싫다면?',
    },
    wonju: {
      no: 4,
      path: 'wonju',
      label: '강원 원주 4호점',
      title: '강원 원주점(비과밀억제권역)',
      detail: `강원 원주점은 비과밀억세권역으로 각종 세제혜택에 유리합니다.
상주/비상주 오피스를 전국에서 가장 저렴한 가격으로 이용할 수 있습니다.`,
      tel: '010-4239-8279',
      scroll: '오픈 특가 이벤트 진행 중!✨✨',
    },
    daegu: {
      no: 5,
      path: 'daegu',
      label: '대구 칠곡 5호점',
      title: '대구 칠곡점(비과밀억제권역)',
      detail: `대구 칠곡점은 학정역 근처에 인접해있습니다.
상주(준비중)/비상주 오피스를 합리적인 가격으로 이용할 수 있습니다.`,
      tel: '0507-1478-5053',
      scroll: '오픈 특가 이벤트 진행 중!✨✨',
    },
    bugae: {
      no: 6,
      path: 'bugae',
      label: '인천 부개 6호점',
      title: '인천 부개점',
      detail: `인천부개점은 타 공유오피스에 비해 가장 합리적인 금액으로 비상주 사무실을 제공합니다.
스터디카페도 최저가 수준으로 운영중이며, 개인석 이용시 오픈석을 무료로 제공합니다.`,
      tel: '032-278-0909',
      scroll: '가장 합리적인 가격으로 제공합니다✨✨',
    },
    yongam: {
      no: 7,
      path: 'yongam',
      label: '청주 용암 7호점',
      title: '청주 용암점',
      detail: `합리적인 가격으로 업무에 필요한 모든 시설을 제공하는 "청주용암점"에서 성공적인 비즈니스의 시작을 함께하세요!
2인실부터 4인실까지, 외창이 있는 넓고 쾌적한 공간에서 보다 효율적이고 편안한 업무 환경을 경험하실 수 있습니다`,
      tel: '043-715-3177',
      scroll: '넓고 쾌적한 업무환경을 원하신다면?!✨✨',
    },
    anyang: {
      no: 8,
      path: 'anyang',
      label: '경기 안양역 8호점',
      title: '경기 안양역점',
      detail: `안양역 도보 5분 거리의 안양 1번가 내에 위치하였습니다.
전좌석 고급 시디즈 의자로 구성되어 편안하고 넓은 사무실을 합리적인 가격으로 이용할 수 있습니다.
`,
      tel: '0507-1373-8321',
      scroll: '오픈 특가 0원 이벤트 진행 중!✨✨',
    },
    jeongwang: {
      no: 9,
      path: 'jeongwang',
      label: '시흥 정왕 9호점',
      title: '시흥 정왕점 (비과밀억제권역)',
      detail: `온잇 시흥 정왕점은 단독층의 110평 가량의 넓은 상주 사무실을 갖추고 있습니다. 
또한 오픈형 사무실과 스터디 카페도 있어 일과 학습이 모두 가능한 곳입니다.
전좌석 시디즈 의자로 편안한 업무와 학습을 지원해 드립니다. `,
      tel: '031-365-5865',
      scroll: '오픈 특가 이벤트 진행 중!✨✨',
    },
    // daegu - yongsan
    yongsan: {
      no: 10,
      path: 'yongsan',
      label: '대구 용산 10호점',
      title: '대구 용산점 (비과밀억제권역)',
      detail: `온잇 스터디카페&공유오피스(용산점)은 가장 합리적인 금액으로 비상주 사무실과 스터디카페를 제공합니다.
  법인설립, 사업자등록, 임대차계약, 실사대응, 우편물 관리 등 모든 방면에서 서포트가 가능합니다.`,
      tel: '053-721-7427',
      scroll: '오픈 특가 이벤트 진행 중!✨✨',
    },
    gyeyang: {
      no: 11,
      path: 'gyeyang',
      label: '인천 계양구청 11호점',
      title: '인천 계양구청점',
      detail: `모든 호실은 창문이 있으며 1인실, 2인실, 다인실로 제공됩니다.
2평 내외의 넉넉한 1인실은 여유로운 분위기에서 업무에 집중하실 수 있습니다.`,
      tel: '032-548-2205',
      tel2: '0507-1392-9263',
      scroll: '오픈 이벤트 진행중✨✨',
    },
    bokdae: {
      no: 12,
      path: 'bokdae',
      label: '청주 복대 12호점',
      title: '청주 복대점 (비과밀억제권역)',
      detail: `모든 호실은 창문이 있으며 1인실, 2인실, 3인실로 제공됩니다.
2평 내외의 넉넉한 1인실은 여유로운 분위기에서 업무에 집중하실 수 있습니다.`,
      tel: '043-233-4856',
      tel2: '010-5585-4856',
      scroll: '6개월/12개월 이상 완납시 할인 이벤트 진행중✨✨',
    },
    apgujeong: {
      no: 13,
      path: 'apgujeong',
      label: '서울 압구정 13호점',
      title: '서울 압구정점 (역세권 도보2분)',
      detail: `최신 인테리어로 넓은 방과 큰 창의 2인실, 4인실을 합리적인 가격으로 이용 가능합니다.
비상주 사무실은 오픈행사 압구정 최저가로 할인 및 추가제공 가능합니다(변동)`,
      tel: '02-6956-0500',
      tel2: '010-5957-0555',
      scroll: '오픈행사 압구정 추가 제공이벤트 진행중✨✨',
    },
    amsa: {
      no: 14,
      path: 'amsa',
      label: '서울 암사 14호점',
      title: '서울 암사점 (역세권 도보5분)',
      detail: `모든 호실은 개별 냉난방으로 운영하며 1인실, 2인실을 다량으로 보유하고 있습니다.
또한 상주 입주자에게 6인실 대형 미팅룸을 무료로 제공하고 있습니다.`,
      tel: '02-442-0156',
      tel2: '010-6427-0156',
      scroll: '쾌적한 신설 공유 오피스✨✨',
    },
    baegot: {
      no: 15,
      path: 'baegot',
      label: '시흥 배곧 15호점',
      title: '시흥 배곧점',
      detail: `합리적인 가격으로 업무에 필요한 시설을 제공하는 온잇 배곧점에서 성공적인 비즈니스의 시작을 함께하세요!
1인실부터 회의실까지, 외창이 있는 넓고 쾌적한 공간에서 효율적이고 편안한 업무 환경을 경험하실 수 있습니다.`,
      tel: '0507-1377-3469',
      tel2: '',
      scroll: '오픈행사 진행중✨✨',
    },
    hakik: {
      no: 16,
      path: 'hakik',
      label: '인천 학익 16호점',
      title: '인천 학익점',
      detail: `온잇 공유오피스는 여라분의 비즈니스에 최적화된 업무 공간을 제공합니다.
인하대, 인천법원 인근에 인접해있으며 상주/비상주 사무실을 합리적인 가격으로 이용할 수 있습니다.`,
      tel: '032-873-4098',
      tel2: '',
      scroll: '가성비 오피스를 구하신다면✨✨',
    },
    seouluni: {
      no: 17,
      path: 'seouluni',
      label: '서울 서울대 17호점',
      title: '서울대점(서울대입구역 도보3분)',
      detail: `신규 오픈 시설로 업무효율을 높이세요. 
합리적인 가격으로 1인실, 2인실 상주사무실 이용가능합니다.`,
      tel: '02-883-8632',
      tel2: '',
      scroll: '오픈행사 진행중✨✨',
    },
    byeoryang: {
      no: 20,
      path: 'byeoryang',
      label: '과천 별양 20호점',
      title: '과천별양점',
      detail: `일하다, 문득 숲.
나만의 리듬으로 일하는 일잘러들의 아지트`,
      tel: "02-504-1220",
      tel2: "010-3389-5860",
      scroll: '오픈행사 진행중✨✨',
    },
    jakjeon: {
      no: 21,
      path: 'jakjeon',
      label: '인천 작전 21호점',
      title: '인천 작전점',
      detail: `모든 호실은 창문이 있으며 1인실, 2인실, 다인실로 제공됩니다.
2평 내외의 넉넉한 1인실은 여유로운 분위기에서 업무에 집중하실 수 있습니다.`,
      tel: '032-548-2205',
      tel2: '0507-1392-9263',
      scroll: '오픈 이벤트 진행중✨✨',
    },
    bangi: {
      no: 24,
      path: 'bangi',
      label: '서울 방이 24호점',
      title: '서울 방이점(방이역 도보1분)',
      detail: `깔끔하고 쾌적한 신규 오픈 시설로 업무효율을 높이세요.
전좌석 고급 시디즈 의자로 구성되어 편안하고 넓은 사무실을 합리적인 가격으로 이용가능합니다.`,
      tel: '0507-1363-5282',
      tel2: '',
      scroll: '오픈 이벤트 진행중✨✨',
    },
    yullyang: {
      no: 26,
      path: 'yullyang',
      label: '청주 율량 26호점',
      title: '청주 율량점',
      detail: `편안한 분위기의 1인실/2인실/3인실/4인실 사무실이 구성되어 있습니다.
주변의 다양한 상권이 모여있으며, 상주/비상주 사무실을 합리적인 가격대로 이용할 수 있습니다.`,
      tel: '010-6492-3579',
      tel2: '0507-1315-3581',
      scroll: '오픈 이벤트 진행중✨✨',
    },
  },
};

export default Landing;
export type { iIntroDetail, iLanding };
